import React from 'react';
import {SVGModel} from '../../../framework.visual/model/svgModel';

export const MinimizeSVG = ({className} : SVGModel) => (
    <svg className={className} viewBox="0 0 32 32">
        <path d="M 0.0662,19.362318 C 0.0298,19.325879 0,17.783024 0,15.933748 V 12.571429 H 16 32 V 16 19.428572 H 16.06625 c -8.76356,0 -15.96356,-0.02981 -16,-0.06625 z"/>
    </svg>
);


